import { Route, Routes, BrowserRouter, useNavigate, useLocation, Router } from 'react-router-dom';
import Home from "./Home";
import { useEffect, useState } from 'react';
import Speakers from "../Speakers/Speakers.jsx";
import SpeakerInfo from "../Speakers/SpeakerInfo.jsx";
import Schedule from "../Schedule/Schedule.jsx";
import LoginForm from "../Login/LoginForm.jsx";
import ProfilePage from "./ProfilePage.jsx";
import LoadExternalLinks from "./Shared/LoadExternalLinks.jsx";
import Delegateslist from "../Delegates/Delegateslist.jsx";
import Auctions from "../Auctions/Auctions.jsx";
import PostsView from "../Posts/PostsView.jsx";
import Conversations from "../Posts/Conversations.jsx";
import Evaluation from "./Evaluation.jsx";
import SponsorInfo from "../Sponsors/SponsorInfo.jsx";
import sponsorsVertical from "./Shared/SponsorsVertical.jsx";
import SessionTracks from "../Schedule/SessionTracks.jsx";
import VirtualExpoRoom from "../VirtualExpo/VirtualExpoRoom.jsx";
import VirtualExpoHall from "../VirtualExpo/VirtualExpoHall.jsx";
import VirtualExpoMultiRooms from "../VirtualExpo/VirtualExpoMultiRooms.jsx";
import SessionInfo from "../Schedule/SessionInfo.jsx";
import Speakers2 from "../Speakers2/Speakers2.jsx";
import SpeakerInfo2 from "../Speakers2/SpeakerInfo2.jsx";
import SponsorsByCategory from "./Shared/SponsorsByCategory.jsx";
import Html1 from "./Shared/Html1.jsx";
import Html2 from "./Shared/Html2.jsx";
import Html3 from "./Shared/Html3.jsx";
import Html4 from "./Shared/Html4.jsx";
import Html5 from "./Shared/Html5.jsx";
import Html6 from "./Shared/Html6.jsx";
import Notifications from "../Notifications/Notifications.jsx";
import ProfileTabs from "../Profile/ProfileTabs.jsx";
import SessionInfo2 from "../SessionInfo2/SessionInfo2.jsx";
import Delegateslist2 from "../Delegates/Delegateslist2.jsx";
import Speakers3 from "../Speakers3/Speakers3.jsx";
import SucessfullLogin from "../Login/SucessfullLogin.jsx";
import RegistrationHome from "../Registration/RegistrationHome.jsx";
import LoginIntro from "../Login/LoginIntro.jsx";
import MeetupsHome from "../Meetups/MeetupsHome.jsx";
import ExhibitorSubmitForm from "../SubmissionForms/ExhibitorSubmitForm.jsx";
import RepresentativeList from "../Representative/RepresentativeList.js";
import RepresentativeEditor from "../Representative/RepresentativeEditor.js";
import Menu1 from "./Shared/Menu1.jsx";
import Menu2 from "./Shared/menu2.jsx";
import Menu3 from "./Shared/menu3.jsx";
import Menu4 from "./Shared/Menu4.jsx";
import Menu5 from "./Shared/Menu5.jsx";
import SpeakerProfile from "../Speaker/SpeakerProfile.jsx";
import SponsorSubmitForm from "../SubmissionForms/SponsorSubmitForm.jsx";
import LogInForm from '../Login/LoginForm.jsx';
import Sponsors from '../Sponsors/Sponsors.jsx';
import Contact from '../Contact/Contact.jsx';
import Registrationform from '../Registration/Registrationform.jsx';
import AttendeeChatNotifications from '../Notifications/AttendeeChatNotifications.jsx';
import { clearGlobalVariables } from './ConfigHelperFunction.jsx';
import MenuBar2 from '../Menubar/MenuBar2.jsx';



const Routers = (props) => {


    const [login, setLogin] = useState(false)

    const menuReloadHandler = () => {
        if (global.$loginstatus.includes("true")) {
            setLogin(true)
        }
        else {
            setLogin(false)
        }

    }
    const handleChange = () => { }

    return (
        <>
            <MenuBar2 login={login} setLogin={setLogin} />

            <Routes>
                <Route path="/" element={<Home s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/Home" element={<Home s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path='/LoginForm' element={<LogInForm onMenuReload={menuReloadHandler} />} />
                <Route path='/Logout' element={<LogInForm onMenuReload={menuReloadHandler} />} />
                <Route path="/Schedule" element={<Schedule type={"schedule"} />} />
                <Route path="/Notifications" element={<AttendeeChatNotifications />} />
                <Route path="/ProfileTabs" element={<ProfileTabs />} />

                <Route path="/Html1" element={<Html1 />} />
                <Route path="/Html2" element={<Html2 />} />
                <Route path="/Html3" element={<Html3 />} />
                <Route path="/Html4" element={<Html4 />} />
                <Route path="/Html5" element={<Html5 />} />
                <Route path="/Html6" element={<Html6 />} />
                <Route path="/Menu1" element={<Menu1 />} />
                <Route path="/Menu2" element={<Menu2 />} />
                <Route path="/Menu3" element={<Menu3 />} />
                <Route path="/Menu4" element={<Menu4 />} />
                <Route path="/Menu5" element={<Menu5 />} />

                <Route
                    path="/LoginIntro"
                    element={<LoginIntro s3={props.s3} code={props.code} bucket={props.bucket} openpopup={true} />}
                />

                <Route
                    path="/Speakers"
                    element={<Speakers s3={props.s3} code={props.code} bucket={props.s3bucket} onchange={handleChange} />}
                />
                <Route
                    path="/SpeakerInfo/:value"
                    element={<SpeakerInfo s3={props.s3} code={props.code} bucket={props.s3bucket} onchange={handleChange} />}
                />

                <Route
                    path="/Speakers2"
                    element={<Speakers2 s3={props.s3} code={props.code} bucket={props.s3bucket} onchange={handleChange} />}
                />

                <Route
                    path="/Speakers3"
                    element={<Speakers3 s3={props.s3} code={props.code} bucket={props.s3bucket} onchange={handleChange} />}
                />

                <Route
                    path="/SpeakerInfo2/:value"
                    element={<SpeakerInfo2 s3={props.s3} code={props.code} bucket={props.s3bucket} onchange={handleChange} />}
                />


                <Route path="/Schedule" element={<Schedule type={"schedule"} key={'schedule'} />} />
                <Route path="/Posters" element={<Schedule type={"posters"} key={'posters'}/>} />
                <Route path="/SessionInfo/:value" element={<SessionInfo />} />
                <Route path="/SessionInfo2/:value" element={<SessionInfo2 />} />

                <Route path="/Exhibitors" element={<Sponsors s3={props.s3} code={props.code} bucket={props.bucket} type={"exhibitors"} key={'exhibitors'} />} />
                <Route path="/Sponsors" element={<Sponsors s3={props.s3} code={props.code} bucket={props.bucket} type={"sponsors"} key={'sponsors'}/>} />
                <Route path="/SponsorsVertical" element={<sponsorsVertical s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/SponsorsByCategory" element={<SponsorsByCategory s3={props.s3} code={props.code} bucket={props.bucket} />} />



                <Route path="/Auctions" element={<Auctions s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/Delegateslist" element={<Delegateslist code={props.code} />} />
                <Route path="/Delegateslist2" element={<Delegateslist2 code={props.code} />} />

                <Route path="/Contact" element={<Contact s3={props.s3} code={props.code} />} />
                <Route path="/MeetupsHome" element={<MeetupsHome s3={props.s3} code={props.code} />} />

                <Route path="/Registrationform" element={<Registrationform />} />
                <Route path="/RegistrationHome" element={<RegistrationHome />} />
                <Route path="/ProfilePage" element={<ProfilePage />} />
                <Route path="/SpeakerProfile" element={<SpeakerProfile />} />
                <Route path="/LoadExternalLinks/:value" element={<LoadExternalLinks />} />
                <Route path="/Evaluation/:value" element={<Evaluation />} />
                <Route path="/SponsorInfo/:value" element={<SponsorInfo />} />
                <Route path="/SessionTracks/:value" element={<SessionTracks />} />

                <Route path="/Conversations" element={<Conversations s3={props.s3} code={props.code} receiverid="public" />} />
                <Route path="/VirtualExpoRoom" element={<VirtualExpoRoom s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/VirtualExpoRoom1" element={<VirtualExpoRoom s3={props.s3} code={props.code} bucket={props.bucket} tag={"room1"} />} />
                <Route path="/VirtualExpoRoom2" element={<VirtualExpoRoom s3={props.s3} code={props.code} bucket={props.bucket} tag={"room2"} />} />
                <Route path="/VirtualExpoMultiRooms" element={<VirtualExpoMultiRooms s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/VirtualExpoHall" element={<VirtualExpoHall s3={props.s3} code={props.code} bucket={props.bucket} />} />


                <Route path="/ExhibitorSubmitForm" element={<ExhibitorSubmitForm s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/SponsorSubmitForm" element={<SponsorSubmitForm s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/Representative" element={<RepresentativeList s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/Representative/RepresentativeEditor/:userid" element={<RepresentativeEditor s3={props.s3} code={props.code} bucket={props.bucket} />} />
                <Route path="/LoginHome" element={<SucessfullLogin s3={props.s3} code={props.code} bucket={props.bucket} />} />
            </Routes>
            
        </>

    );
}

export default Routers